import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { IContactUpdateResource } from "../../shared/types";
import {
	PrimaryLabel,
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItemWrapper,
} from "../../shared/view";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: companies;
`;

const CompanyWrapper = styled.div`
	display: grid;
`;

const StyledPrimaryLabel = styled(PrimaryLabel)`
	align-self: center;
`;

export const ArchivedContactViewCompaniesSection: FC<{ contact: IContactUpdateResource }> = ({ contact }) => {
	const { t } = useTranslation();

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Companies")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{contact.companies.map((x) => (
					<ViewPageSectionListItemWrapper key={x.id}>
						<CompanyWrapper>
							<span>{x.name}</span>
							<span>{x.position}</span>
						</CompanyWrapper>
						{x.isPrimary && <StyledPrimaryLabel />}
					</ViewPageSectionListItemWrapper>
				))}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
